export default {
  1: 'Agendado',
  2: 'Atrasado',
  3: 'Confirmado',
  4: 'Finalizado',
  5: 'Bloqueado',
  6: 'Reserva',
  7: 'Agendamento do Airbnb',
}